import { CardContent, Typography } from "@material-ui/core";
import { memo } from "react";

interface IEmptyComponentProps {
  message?: string;
  useFixedHeight?: boolean;
}

const Empty = ({ message, useFixedHeight }: IEmptyComponentProps) => {
  return (
    <CardContent style={useFixedHeight ? { height: 352 } : null}>
      <Typography variant="body2">{message || "No results found"}</Typography>
    </CardContent>
  );
};

export default memo(Empty);
